<template>
  
    <div class="content">
      <v-flex align-self-center>
      <h2>招标公告</h2>
      </v-flex>
      <v-flex>
        <article>
          <h3>项目概况</h3>
          <p>张家川回族自治县乡村振兴局防返贫保险项目的潜在投标人应在张家川回族自治县人民政府(<a href="http://zwgk.zjc.gov.cn/index.php?m=content&c=index&a=lists&catid=905" target="_blank">zwgk.zjc.gov.cn/index.php?m=content&c=index&a=lists&catid=905</a>)或易才保险经纪(<a href="https://www.dhjyib.com/" target="_blank">dhjyib.com</a>)获取招标文件，并于2021年7月8日14点30分前递交投标文件。</p>
          <h4>一、项目基本情况</h4>
          <p>项目编号：ZJC-FFPX-2021-001</p>
          <p>项目名称：张家川回族自治县乡村振兴局防返贫保险项目</p>
          <p>预算金额：91.00万元。</p>
          <p>最高限价：91.00万元。</p>
          <p>采购需求：为全县脱贫不稳定、边缘易致贫、基本生活出现严重困难的 “三类人口”购买防返贫保险,共计9100人。</p>
          <p>合同履行期限：一年。</p>
          <p>本项目不接受联合体投标。</p>
          <h4>二、申请人的资格要求：</h4>
          <p>1.满足《中华人民共和国政府采购法》第二十二条规定。</p>
          <p>（1）具有独立承担民事责任的能力；（须提供有效的营业执照、组织机构代码证、税务登记证或具有统一社会信用代码的营业执照副本）；</p>
          <p>（2）具有良好的商业信誉和健全的财务会计制度（若企业成立期限不足一年者以营业执照实际成立期限为准，并按实际成立期限之日起提供财务报表）；</p>
          <p>（3）具有履行合同所必需的设备和专业技术能力（具有与本次采购内容相符的经营范围）；</p>
          <p>（4）有依法缴纳税收和社会保障资金的良好记录（须提供2020年1月至今任意一个月纳税凭证和缴纳社会保险的凭证）；</p>
          <p>（5）参加本次政府采购活动近三年（2018年1月至今）内，在经营活动中没有重大违法记录（须提供企业声明函原件）；</p>
          <p>（6）法律、行政法规规定的其他条件；</p>
          <p>（7）须提供法定代表人资格证明、身份证（法定代表人参与投标时提供）或附有法定代表人身份证复印件的法人授权函，被授权人身份证（非法定代表人参与投标时提供）；</p>
          <p>（8）投标人未被列入“信用中国”网站(<a href="https://www.creditchina.gov.cn/" target="_blank">www.creditchina.gov.cn</a>)记录失信被执行人或重大税收违法案件当事人名单或政府采购严重违法失信行为”记录名单；不处于中国政府采购网(<a href="http://www.ccgp.gov.cn/" target="_blank">www.ccgp.gov.cn</a>)政府采购严重违法失信行为信息记录”中的禁止参加政府采购活动期间;最终由资格审查小组对各供应商信用记录进行甄别。（查询时间为公告发布之日起）</p>
          <p>2.需要落实的政府采购政策：</p>
          <p>（1）根据财政部发布的《政府采购促进中小企业发展管理办法》规定，本项目对小型和微型企业产品的价格给予6%的扣除；</p>
          <p>（2）根据财政部发布的《关于政府采购支持监狱企业发展有关问题的通知》规定，本项目对监狱企业产品的价格给予6%的扣除；</p>
          <p>（3）根据财政部、民政部、中国残疾人联合会发布的《关于促进残疾人就业政府采购政策的通知》规定，本项目对残疾人福利性单位产品的价格给予6%的扣除。</p>
          <p>3.本项目的特定资格要求：</p>
          <p>（1）供应商须具有中国保险监督管理委员会颁发的经营保险业务许可证;</p>
          <p>（2）供应商为分公司或分支机构的，必须取得省级以上公司授权；</p>
          <p>（3） 投标人须为未被列入“信用中国”网站（<a href="https://www.creditchina.gov.cn/" target="_blank">www.creditchina.gov.cn</a>）记录“失信被执行人”或“重大税收违法案件当事人名单”或“政府采购严重违法失信行为”记录名单；不处于中国政府采购网（<a href="http://www.ccgp.gov.cn/" target="_blank">www.ccgp.gov.cn</a>）“政府采购严重违法失信行为信息记录”中的禁止参加政府采购活动期间；（以招标公告发布之日起在 “信用中国”网站（<a href="https://www.creditchina.gov.cn/" target="_blank">www.creditchina.gov.cn</a>）、中国政府采购网（<a href="http://www.ccgp.gov.cn/" target="_blank">www.ccgp.gov.cn</a>）查询结果为准，如相关失信记录已失效，投标人需提供相关证明资料）；</p>
          <p>（4）投标人须提供通过中国“中国裁判文书网”网站（<a href="http://wenshu.court.gov.cn/" target="_blank">wenshu.court.gov.cn/</a>）渠道查询无行贿犯罪结果（以网上查询结果打印并加盖单位公章为准， 查询内容包含企业名称及企业法人）。</p>
          <h4>三、获取招标文件</h4>
          <p>时间：2021年6月24日至2021年6月30日，每天上午00时00分00秒至11时59分59秒，下午12时00分00秒至23时59分59秒（北京时间，法定节假日除外）。</p>
          <p>地点：登录张家川回族自治县人民政府(<a href="http://zwgk.zjc.gov.cn/index.php?m=content&c=index&a=lists&catid=905" target="_blank">zwgk.zjc.gov.cn/index.php?m=content&c=index&a=lists&catid=905</a>)或易才保险经纪(<a href="https://www.dhjyib.com/" target="_blank">dhjyib.com</a>)获取招标文件。</p>
          <p>售价：0元。</p>
          <h4>四、提交投标文件截止时间、开标时间和地点</h4>
          <p>时间：2021年7月8日14点30分（北京时间，逾期不再受理）。</p>
          <p>地点：甘肃省天水市张家川县阿阳大道影视中心2楼会议室（现场开标）。</p>
          <h4>五、公告期限</h4>
          <p>自本公告发布之日起5个工作日。</p>
          <h4>六、对本次招标提出询问，请按以下方式联系。</h4>
          <p>1.采购人信息</p>
          <p>名	称：张家川回族自治县乡村振兴局</p>
          <p>地	址：甘肃省天水市张家川县阿阳大道影视中心2楼振兴局</p>
          <p>联系方式：0938-7883800</p>
          <p>2.采购顾问机构信息</p>
          <p>名	称：易才宏业保险经纪有限公司</p>
          <p>地址：天津市河西区黑牛城道与洞庭路交口东南侧五福大厦-1-1407、-1-1408</p>
          <p>联系方式：010-50947000</p>
          <p>3.项目联系方式 </p>
          <p>项目联系人：韩丰</p>
          <p>电	话：13520206655</p>
          <p>邮  箱：feng.han@chinatalentgroup.com</p>
          <h4>附件:</h4>
          <p><a href="https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/gongshi/1.pdf" download="张家川县2021年“防返贫”保险项目招标文件.pdf">张家川县2021年“防返贫”保险项目招标文件.pdf</a></p>
          <p><a href="https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/gongshi/2.docx" download="张家川县2021年“防返贫”保险项目招标文件.docx">张家川县2021年“防返贫”保险项目招标文件.docx</a></p>
        </article>
      </v-flex>
    </div>
  
</template>
<script>
export default {
  data() {
    return {};
  },
  
};
</script>
<style lang="scss" scoped>
// @media only screen and (min-width: 1280px){
//   .about{
//     .container {
//       max-width: 900px !important;
//     }
//   }
// }
.content {
  border-left: 1px solid #e4e4e4;
  padding-left:20px;
  margin-bottom: 40px;
  margin-top: 60px;
  h2 {
    margin-top: 0;
    font-size: 36px;
    font-weight: 400;
    text-align: center;
   
  }
  h3 {
    text-align: center;
  }
}
article p {
  text-indent: 2em;
  font-size: 16px;
  color: #666;
}

// .about-header {
//   width: 100%;
//   height: 377px;
//   background: url("/images/about/about-bg.png") no-repeat center center;
//   background-size: cover;
//   text-align: center;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   p {
//     font-size: 30px;
//     font-weight: 500;
//     color: #fff;
//   }
// }
// @media screen and (max-width: 600px) {
//   .about-header p{
//     font-size:28px ;
//   }
//   .about {
//     h2 {
//       font-size: 26px;
//       font-weight: 400;
//       margin-bottom: 18px;
//       margin-top: 50px;
//     }
//   }
  
//   article,.about-img,.contact{
//     padding: 0 15px;
//   }
// }
</style>